var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{attrs:{"height":_vm.height,"src":_vm.image ? _vm.s3BucketURL + _vm.image : _vm.images[_vm.default_image],"width":_vm.width ? _vm.width : 'auto',"contain":_vm.contain ? false : true}},[_vm._t("overlay")],2)}
var staticRenderFns = []

export { render, staticRenderFns }